import { Button, Typography } from '@mui/material';
import React from 'react';
import Column from 'src/frontend-common/components/Column';
import { LandingState } from 'src/pages/LoginSimulatorLanding';
import SuccessImg from 'src/pages/LoginSimulatorLanding/success.png';
import FailImg from 'src/pages/LoginSimulatorLanding/fail.png';
import { TextWrapper } from 'src/pages/LoginSimulatorLanding/style';
import Row from 'src/frontend-common/components/Row';

export const textSecondarySuccess = `The Login user performed matched with the enrollment device`;
export const textSecondaryFail = `The Login user performed doesn’t matched with the enrollment device`;

const LoginSimulatorOutcome: React.FC<{
  landingState: LandingState;
  setLandingState: React.Dispatch<React.SetStateAction<LandingState>>;
  isNotLanding?: boolean;
  resetAll?: () => void;
  setCurrentStep?: React.Dispatch<React.SetStateAction<number>>;
}> = ({ landingState, setLandingState, isNotLanding = false, resetAll, setCurrentStep }) => {
  const handleRetry = () => {
    setLandingState('form');
    if (resetAll) resetAll();
  };

  const handleBack = () => {
    setLandingState('form');
    if (setCurrentStep) setCurrentStep((prev) => prev - 1);
  };

  return (
    <>
      {isNotLanding ? (
        <Column style={{ alignItems: 'center', marginTop: 24 }}>
          <img style={{ width: 75 }} src={landingState === 'success' ? SuccessImg : FailImg} alt="Outcome Icon" />
          <TextWrapper marg={undefined}>
            <Typography variant="h2">{landingState === 'success' ? 'Login Successfull' : 'Login Failed'}</Typography>
            <Typography variant="body2">{landingState === 'success' ? textSecondarySuccess : textSecondaryFail}</Typography>
          </TextWrapper>

          <Row
            style={{
              width: 'calc(100% - 32px)',
              justifyContent: 'space-between',
              marginTop: '24px',
            }}
          >
            <Button variant="outlined" color="primary" onClick={handleBack}>
              Back
            </Button>
            <Button variant="contained" color="primary" onClick={handleRetry}>
              New Enrollment
            </Button>
          </Row>
        </Column>
      ) : (
        <Column
          style={{
            alignItems: 'center',
            padding: 56,
            backgroundColor: 'white',
            border: 'none',
            boxShadow: '0px 15px 35px -8px rgba(0, 0, 0, 0.08)',
            marginTop: 0,
          }}
        >
          <TextWrapper marg={'true'}>
            <Typography variant="h2">{landingState === 'success' ? 'Login Successfull' : 'Login Failed'}</Typography>
            <Typography variant="body2">{landingState === 'success' ? textSecondarySuccess : textSecondaryFail}</Typography>
          </TextWrapper>
          <img style={{ width: 180, marginBottom: 0 }} src={landingState === 'success' ? SuccessImg : FailImg} alt="Outcome Icon" />
        </Column>
      )}
    </>
  );
};

export default LoginSimulatorOutcome;
